<template>
  <div class="couponadd" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据提交中..." element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:35px"></div>
    <ul class="lsls">
      <li>
        <h2>{{message_id == 1 ? '微信短信下发（随机发放50条）' : '平台短信下发（随机发放50条）'}}</h2>
      </li>
      <li>
        <span>服务名称</span>
        <input type="text" v-model="title" placeholder="请输入服务名称" />
      </li>
      <li>
        <span>出行地址</span>
        <input type="text" v-model="address" placeholder="请输入出行地址"/>
      </li>
      <li>
        <span>跳转链接</span>
        <input type="text" v-model="url" placeholder="请输入跳转链接"/>
      </li>
      <li>
        <span>内容描述</span>
        <textarea placeholder="请输入内容描述" v-model="content"></textarea>
      </li>

    </ul>
    <button class="addAddress" @click="save">立即发送</button>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        userData:[],
        title:'',
        url:'',
        address:'',
        content:'',
        message_id:0
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      this.message_id =  this.$route.query.id;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
    },
    created(){
      this.userData = localStorage.getItem('user') == null ? [] : JSON.parse(localStorage.getItem('user'));
    },
    mounted() {
      this.beforeMount();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },

      save:function(){
        var that = this;
        if(that.title == ''){
          alert('请输入服务名称');
          return false;
        }
        if(that.address == ''){
          alert('请输入出行地址');
          return false;
        }
        if(that.content == ''){
          alert('请输入内容描述');
          return false;
        }
        if(that.url == ''){
          alert('请输入跳转链接');
          return false;
        }
        var id = this.$route.query.id;
        var mall_id = this.$route.query.mall_id;
        that.fullscreenLoading = true;
        this.axios({
          method:'post',
          url:that.$host+'home/message/sendSms',
          params:{
            title:that.title,
            address:that.address,
            content:that.content,
            status:id,
            url:that.url,
            user_id:that.userData.id,
            mall_id:mall_id
          }
        }).then(function(response){
          that.fullscreenLoading = false;
          var res = response.data;
          if(res.status == 200){
            that.$router.go(-1)
          }else{
            alert(res.message);
          }
          
        }).catch(err=>{
          that.fullscreenLoading = false;
            console.log('请求失败:'+err);
        });
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .couponadd{
    max-width:640px;
    background:#f7faff;
    margin:0 auto;
  }
  .couponadd ul.lsls{
    display:block;
    width:92%;
    background:#fff;
    margin:0 auto;
    margin-bottom:80px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
  }
  .couponadd ul.lsls li{
    width:92%;
    margin:0 auto;
    border-bottom:solid 1px #EBF2FF;
    padding:15px 0;
    position: relative;
  }
  .couponadd ul.lsls li font{
    position:absolute;
    right:15px;
    bottom:15px;
    font-size:16px;
    color:#FF751A
  }
  .couponadd ul li:first-child h2{
    font-size:16px
  }
  .couponadd li:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .couponadd ul li span{
    display:block;
    width:100%;
    font-size:16px;
    padding-bottom:15px
  }
  .couponadd ul li input{
    display:block;
    width:100%;
    background:none;
    border:none;
    outline:none;
    font-size:16px;
    margin-top:1px;
  }
  .couponadd ul li .checkbox{
    float:right;
    width:auto !important;
    margin-right:30px;
    margin-top:4px
  }
  .couponadd ul li textarea{
    float:left;
    width:78%;
    height:50px;
    background:none;
    border:none;
    outline:none;
    font-size:15px;
    resize: none;
  }
  .couponadd .addAddress{
    display:block;
    margin:0 auto;
    width:80%;
    height:45px;
    border:none;
    background:#2F78FF;
    color:#fff;
    font-size:16px;
    border-radius:45px;
  }


</style>